import withMultipleLangFiles from './withMultipleLangFiles';
import withCompetenciesFiles from './withCompetenciesFiles';
import withGoogleDocsCompetenciesFiles from './withGoogleDocsCompetenciesFiles';
import withAttachmentsFiles from './withAttachmentsFiles';
import withMultiplyByHundred from './withMultiplyByHundred';
import withButtonLink from './withButtonLink';
import withMinuteFile from './withMinuteFile';
import withModalForm from './withModalForm';
import withTabsParams from './withTabsParams';
import withPurchaseOrderPdf from './withPurchaseOrderPdf';
import withPdfDropzone from './withPdfDropzone';
import withValidationOrderPdf from './withValidationOrderPdf';
import withContractSignatureConsent from './withContractSignatureConsent';

const extensions = {
  multipleLangFiles: withMultipleLangFiles,
  competenciesFiles: withCompetenciesFiles,
  googleDocsCompetenciesFiles: withGoogleDocsCompetenciesFiles,
  attachmentsFiles: withAttachmentsFiles,
  multiplyByHundred: withMultiplyByHundred,
  buttonLink: withButtonLink,
  minuteFile: withMinuteFile,
  modalForm: withModalForm,
  tabsParams: withTabsParams,
  purchaseOrderPdf: withPurchaseOrderPdf,
  pdfDropzone: withPdfDropzone,
  validationOrderPdf: withValidationOrderPdf,
  contractSignatureConsent: withContractSignatureConsent,
};

export default extensions;
